import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive'
import MovieInfoMobile from './MovieInfo.mobile';



const useStyles = makeStyles(theme => ({
  card: {
    background: '#fff',
    borderRadius: 18,
    border: '1px solid #eee',
    boxShadow: '0 2px 10px rgba(16,16,16,0.05)',
    overflow: 'hidden',
    position: 'sticky',
    top: theme.spacing(3)
  },
  posterWrap: {
    width: '100%',
    aspectRatio: '2 / 3',
    background: '#f2f0ec',
    overflow: 'hidden'
  },
  poster: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  },
  title: {
    padding: theme.spacing(2.25, 2.25, 0.5),
    fontSize: '20px',
    fontWeight: 800,
    color: '#161616',
    textTransform: 'capitalize',
    lineHeight: 1.25
  },
  info: {
    padding: theme.spacing(0.5, 2.25, 2.25)
  },
  infoBox: {
    marginTop: theme.spacing(2)
  },
  infoLabel: {
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: '#aaa'
  },
  infoValue: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#333',
    marginTop: 2
  },
  [theme.breakpoints.down('md')]: {
    card: { position: 'static' }
  }
}));

export default function MovieInfo(props) {
  const classes = useStyles(props);
  const { movie,selectedTime } = props;
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })

  if (!movie) return <h1>Movie Loading...</h1>;

  return (
    <>
    {isTabletOrMobile ? <MovieInfoMobile movie={movie} selectedTime={selectedTime}/> :
    <Grid item xs={12} md={12} lg={3} >
      <div className={classes.card}>
        <div className={classes.posterWrap}>
          <img src={movie.image} alt="movie-poster" className={classes.poster} />
        </div>
        <Typography className={classes.title}>{movie.title}</Typography>
        <div className={classes.info}>
          {movie.director && (
            <div className={classes.infoBox}>
              <Typography className={classes.infoLabel}>Director</Typography>
              <Typography className={classes.infoValue}>{movie.director}</Typography>
            </div>
          )}
          {movie.cast && (
            <div className={classes.infoBox}>
              <Typography className={classes.infoLabel}>Cast</Typography>
              <Typography className={classes.infoValue}>{movie.cast}</Typography>
            </div>
          )}
          {movie.genre && (
            <div className={classes.infoBox}>
              <Typography className={classes.infoLabel}>Genre</Typography>
              <Typography className={classes.infoValue}>{movie.genre}</Typography>
            </div>
          )}
        </div>
      </div>
    </Grid>
     }
    </>
  );
}
